import React from 'react'
import BackButton from '../components/navigation/BackButton'
import {useState, useEffect} from 'react'
import { Link, useParams } from 'react-router-dom'
import PhotoTile from "../components/content/PhotoTile"
import Lightbox from '../components/content/Lightbox/Lightbox'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapPin, faCamera, faCalendar, faTableCells, faTableList,  } from '@fortawesome/free-solid-svg-icons'

const Album = () => {
    const { id } = useParams()
    const [project, setProject] = useState(null)
    const [selectedPhoto, setSelectedPhoto] = useState()

    useEffect(() => {
        fetch("http://127.0.0.1:5000/getProject/" + id)
        .then(response => response.json())
        .then(data => setProject(data))
    }, [id])

    return (
        <div className='container container-page'>
            <div className="container container-subnav">
                <div className="subnav-left">
                    <BackButton toLink="/projects" toName="Projects" />
                </div>
            </div>
            {project && 
            <div className='container container-title'>
                <h1>{project.title}</h1>
                <p>{project.short_desc}</p>
                <div className='metadata'>
                    <div className='metadata-item'><FontAwesomeIcon icon={faCalendar} />{new Date(project.created).toISOString().split('T')[0]}</div>
                    <div className='metadata-item'></div>
                </div>
            </div>}
            <div className=''>
                {project && project.images.map((photo) => {
                    return (
                        <PhotoTile key={photo.id} photo={photo} onClick={() => setSelectedPhoto(photo)} />
                    )
                })}
                {selectedPhoto && <Lightbox photo={selectedPhoto} onClose={() => setSelectedPhoto(null)} />}
            </div>
        </div>
    )
}

export default Album